import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getDataCount } from "@/api/data";
import infoList from "@/mixins/infoList";
import serverList from "../../components/serverList/serverOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
//import { Loading } from "element-ui";

export default {
  mixins: [infoList],
  components: {
    serverList: serverList,
    VxeTable: VxeTable,
    DataOptions: DataOptions
  },
  data: function data() {
    var h = this.$createElement;
    return {
      listApi: getDataCount,
      searchInfo: {
        server_id: []
      },
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableColumn: [{
        field: "date_str",
        title: "日期",
        sortable: true,
        width: 100
      }, {
        field: "new_user",
        title: "新增账号",
        sortable: true,
        width: 100
      }, {
        field: "new_role",
        title: "创角",
        sortable: true,
        visible: false,
        width: 100
      }, {
        field: "activity_user",
        title: "活跃角色",
        sortable: true,
        width: 100
      }, {
        field: "vip_role",
        title: "VIP角色",
        sortable: true,
        visible: false,
        width: 100
      }, {
        field: "new_role_pay_money",
        title: "新增付费金额",
        sortable: true,
        titleHelp: {
          "content": "新增付费金额/新增付费人数"
        },
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            return [h("span", [row.new_role_pay_money, " \u5143 \uFF08", row.new_role_arppu, "\uFF09"])];
          }
        },
        width: 150,
        visible: false
      }, {
        field: "new_role_pay",
        title: "新增付费人数",
        sortable: true,
        titleHelp: {
          "content": "新增付费人数/创角"
        },
        slots: {
          default: function _default(_ref2) {
            var row = _ref2.row;
            return [h("span", [row.new_role_pay, "(", row.new_role_pay_rate, "%)"])];
          }
        },
        width: 120,
        visible: false
      }, {
        field: "keep_role_1_day",
        title: "创角次留",
        sortable: true,
        slots: {
          default: function _default(_ref3) {
            var row = _ref3.row;
            return [h("span", [row.keep_role_1_day, " \uFF08", row.keep_role_1_day_rate, "%\uFF09"])];
          }
        }
      }, {
        field: "pay_money",
        title: "付费金额",
        sortable: true,
        titleHelp: {
          "content": "付费金额/付费人数"
        },
        slots: {
          default: function _default(_ref4) {
            var row = _ref4.row;
            return [h("span", [row.pay_money, "\u5143\uFF08", row.pay_arppu, "\uFF09"])];
          }
        },
        width: 150,
        visible: false
      }, {
        field: "pay_role",
        title: "付费人数",
        sortable: true,
        titleHelp: {
          "content": "付费人数/活跃角色"
        },
        slots: {
          default: function _default(_ref5) {
            var row = _ref5.row;
            return [h("span", [row.pay_role, "(", row.pay_rate, "%)"])];
          }
        },
        width: 100,
        visible: false
      }, {
        field: "arpu",
        title: "arpu",
        sortable: true,
        visible: false
      }, {
        field: "roll_role",
        title: "滚服创角数",
        sortable: true,
        visible: false
      }, {
        field: "roll_money",
        title: "滚服充值金额",
        sortable: true,
        slots: {
          default: function _default(_ref6) {
            var row = _ref6.row;
            return [h("span", [row.roll_money, " \u5143"])];
          }
        },
        visible: false
      }, {
        field: "roll_pay_role",
        title: "滚服付费人数",
        sortable: true,
        visible: false
      }, {
        field: "new_user_watch_video_count",
        titleHelp: {
          "content": "当日新增用户累计观看的总广告次数"
        },
        title: "新增广告次数",
        sortable: true
      }, {
        field: "watch_video_count",
        titleHelp: {
          "content": "当日所有用户累计观看的总广告次数"
        },
        title: "广告次数",
        sortable: true
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.searchEvent();
            _this.footDataToFirst();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    footDataToFirst: function footDataToFirst() {
      var arr1 = document.getElementsByClassName("vxe-table--footer-wrapper");
      var arr2 = document.getElementsByClassName("vxe-table--body-wrapper");
      console.log("arr2[0]", arr2);
      if (arr2[0]) {
        arr2[0].parentNode.insertBefore(arr1[0], arr2[0]);
      }
    },
    searchEvent: function searchEvent() {
      this.searchInfo.sdate = this.formData[0];
      this.searchInfo.edate = this.formData[1];
      this.loadTatleData();
    },
    loadTatleData: function loadTatleData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getTableData();
            case 2:
              if (!_this2.tableData) {
                _this2.$message({
                  message: "暂无数据"
                });
              } else if (_this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};